// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.ChatMessage {
  position: relative;
}
.ChatMessage .message-header-details {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #959AAD;
  font-weight: 300;
}
.ChatMessage .message-header-details .message-avatar {
  position: absolute;
  right: 10px;
  width: 28px;
  height: 28px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: 100%;
}
.ChatMessage .message-header-details .message-avatar img {
  width: 28px;
  height: 28px;
  border-radius: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.ChatMessage.from-user-message {
  display: flex;
  align-items: right;
  flex-direction: column;
  margin-left: auto;
  max-width: 60%;
  width: auto;
  text-align: left;
}
.ChatMessage.from-user-message .message-header-details {
  margin-left: auto;
  position: relative;
}
.ChatMessage.from-user-message .message-header-details .message-date {
  margin-right: 50px;
}
.ChatMessage.from-user-message .message-header-details .message-avatar {
  position: absolute;
  top: -8px;
  right: 8px;
}
.ChatMessage.recipient-user-message {
  display: flex;
  align-items: left;
  flex-direction: column;
  margin-right: auto;
  max-width: 60%;
  width: auto;
  text-align: left;
}
.ChatMessage.recipient-user-message .message-header-details {
  margin-left: 0;
  position: relative;
}
.ChatMessage.recipient-user-message .message-header-details .message-date {
  margin-left: 50px;
}
.ChatMessage.recipient-user-message .message-header-details .message-avatar {
  position: absolute;
  top: -8px;
  left: 8px;
  background-color: #FFFFFF;
}
.ChatMessage .message-date {
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.ChatMessage .message-date .date-at {
  white-space: nowrap;
}
.ChatMessage .message-date .date-at.full-width {
  width: 100%;
}
.ChatMessage .message-date .sender-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  margin-left: 5px;
}
.ChatMessage .message-date .sep {
  font-size: 4px;
  margin: 0 5px;
  vertical-align: 2px;
}
.ChatMessage .chat-message-card {
  margin-top: 3px;
  margin-bottom: 25px;
  border-radius: 4px;
  border: 1px solid #E1E1E9;
}
.ChatMessage .chat-message-card .message-content-container {
  padding: 15px;
  font-size: 14px;
  color: #383838;
}
.ChatMessage .chat-message-card .message-content-container .client-review {
  display: flex;
  align-items: center;
  color: #F66733;
  font-weight: 900;
  margin-bottom: 10px;
}
.ChatMessage .chat-message-card .message-content-container .client-review .client-review-edit-icon {
  margin-right: 5px;
}
.ChatMessage .chat-message-card .message-content-container .message-upload {
  display: flex;
  align-items: center;
  color: #000000;
  font-weight: 700;
  margin-bottom: 10px;
}
.ChatMessage .chat-message-card .message-content-container .message-upload .message-upload-mic-icon {
  margin-right: 5px;
}
.ChatMessage .chat-message-card .message-content-container .message-attachment-upload {
  display: flex;
  align-items: center;
  color: #000000;
  font-weight: 700;
  margin-bottom: 10px;
}
.ChatMessage .chat-message-card .message-content-container .message-attachment-upload .message-attachment-upload-file-icon {
  margin-right: 5px;
}
.ChatMessage .chat-message-card .message-comment .assign-voice-talent .voice-talent-name {
  color: #00A474;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/web/client/src/components/Messages/NewMessageRequest/Sidebar/Chat/ChatMessage.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,kBAAA;AAuFF;AArFE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cDIM;ECHN,gBAAA;AAuFJ;AArFI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;AAuFN;AArFM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AAuFR;AAlFE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AAoFJ;AAlFI;EACE,iBAAA;EACA,kBAAA;AAoFN;AAlFM;EACE,kBAAA;AAoFR;AAjFM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAmFR;AA9EE;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AAgFJ;AA9EI;EACE,cAAA;EACA,kBAAA;AAgFN;AA9EM;EACE,iBAAA;AAgFR;AA7EM;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,yBDtDA;ACqIR;AA1EE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA4EJ;AA1EI;EACE,mBAAA;AA4EN;AA1EM;EACE,WAAA;AA4ER;AAxEI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AA0EN;AAvEI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AAyEN;AArEE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAuEJ;AArEI;EACE,aAAA;EAEA,eAAA;EACA,cD1GK;ACgLX;AApEM;EACE,aAAA;EACA,mBAAA;EACA,cDnHC;ECoHD,gBAAA;EACA,mBAAA;AAsER;AApEQ;EACE,iBAAA;AAsEV;AAlEM;EACE,aAAA;EACA,mBAAA;EACA,cDlHA;ECmHA,gBAAA;EACA,mBAAA;AAoER;AAlEQ;EACE,iBAAA;AAoEV;AAhEM;EACE,aAAA;EACA,mBAAA;EACA,cD9HA;EC+HA,gBAAA;EACA,mBAAA;AAkER;AAhEQ;EACE,iBAAA;AAkEV;AAzDQ;EACE,cDnJA;ECoJA,iBAAA;AA2DV","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '~vibeguide/sass/color.scss' as color;\n\n.ChatMessage {\n  position: relative;\n\n  .message-header-details {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    color: color.$manatee;\n    font-weight: 300;\n\n    .message-avatar {\n      position: absolute;\n      right: 10px;\n      width: 28px;\n      height: 28px;\n      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);\n      border-radius: 100%;\n\n      img {\n        width: 28px;\n        height: 28px;\n        border-radius: 100%;\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);\n        overflow: hidden;\n      }\n    }\n  }\n\n  &.from-user-message {\n    display: flex;\n    align-items: right;\n    flex-direction: column;\n    margin-left: auto;\n    max-width: 60%;\n    width: auto;\n    text-align: left;\n\n    .message-header-details {\n      margin-left: auto;\n      position: relative;\n\n      .message-date {\n        margin-right: 50px;\n      }\n\n      .message-avatar {\n        position: absolute;\n        top: -8px;\n        right: 8px;\n      }\n    }\n  }\n\n  &.recipient-user-message {\n    display: flex;\n    align-items: left;\n    flex-direction: column;\n    margin-right: auto;\n    max-width: 60%;\n    width: auto;\n    text-align: left;\n\n    .message-header-details {\n      margin-left: 0;\n      position: relative;\n\n      .message-date {\n        margin-left: 50px;\n      }\n\n      .message-avatar {\n        position: absolute;\n        top: -8px;\n        left: 8px;\n        background-color: color.$white;\n      }\n    }\n  }\n\n  .message-date {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n\n    .date-at {\n      white-space: nowrap;\n\n      &.full-width {\n        width: 100%;\n      }\n    }\n\n    .sender-name {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      flex-grow: 1;\n      margin-left: 5px;\n    }\n\n    .sep {\n      font-size: 4px;\n      margin: 0 5px;\n      vertical-align: 2px;\n    }\n  }\n\n  .chat-message-card {\n    margin-top: 3px;\n    margin-bottom: 25px;\n    border-radius: 4px;\n    border: 1px solid color.$whiteSmoke;\n\n    .message-content-container {\n      padding: 15px;\n      // padding-top: 20px;\n      font-size: 14px;\n      color: color.$obsidian;\n\n      .client-review {\n        display: flex;\n        align-items: center;\n        color: color.$orange;\n        font-weight: 900;\n        margin-bottom: 10px;\n\n        .client-review-edit-icon {\n          margin-right: 5px;\n        }\n      }\n\n      .message-upload {\n        display: flex;\n        align-items: center;\n        color: color.$black;\n        font-weight: 700;\n        margin-bottom: 10px;\n\n        .message-upload-mic-icon {\n          margin-right: 5px;\n        }\n      }\n\n      .message-attachment-upload {\n        display: flex;\n        align-items: center;\n        color: color.$black;\n        font-weight: 700;\n        margin-bottom: 10px;\n\n        .message-attachment-upload-file-icon {\n          margin-right: 5px;\n        }\n      }\n    }\n\n    .message-comment {\n\n      .assign-voice-talent {\n\n        .voice-talent-name {\n          color: color.$success;\n          font-weight: bold;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
